/* eslint-disable */
<template>
  <v-layout faq>
    <v-content>
      <v-container white--text>
        <index-header :title=" $store.getters.lang === 'es' ? $t('about.headerFaq') : $t('text.faq')"></index-header>

        <v-layout justify-center mb-5>
          <v-flex md8 xs12>
            <v-expansion-panel :dark="true">
              <v-expansion-panel-content v-for="(item, i) in $store.getters.lang === 'es' ? $t('about.faq') : faq" :key="i">
                <div slot="header">
                  <span v-html="item.question"></span>
                </div>
                <v-card>
                  <v-card-text>
                    <span v-html="item.answer"></span>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-layout>
</template>

<script>
import axios from 'axios';
import indexHeader from '@/components/indexHeader';

export default {
  name: 'Faq',
  components: {
    'index-header': indexHeader,
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'E-Komics - ' + this.$t(this.$route.meta.title)
        : 'E-Komics',
    };
  },
  mounted() {
    this.getTermsOfService();
  },
  data() {
    return {
      loaded: false,
      faq: [],
    };
  },
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    es() {
      return this.lang === 'es' || this.lang === 'es_EC';
    },
    pt() {
      return this.lang === 'pt' || this.lang === 'pt_BR';
    },
  },
  methods: {
    getTermsOfService() {
      axios
        .get(`/faqs?page=1&limit=100&lang=${this.lang}`)
        .then((response) => {
          this.faq = response.data.faqs;
          this.loaded = true;

          setTimeout(() => {
            document.querySelector('.v-expansion-panel__header').click();
          }, 200);

          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.faq {
  .theme--dark.v-expansion-panel {
    box-shadow: none !important;

    .v-expansion-panel__container {
      background: none;
      margin-bottom: 20px;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.5) !important;

      .v-expansion-panel__body {
        .v-card {
          background: none !important;

          p {
            font-weight: lighter;
          }
        }
      }
    }
  }
}
</style>
